<template>
  <div class="fxRow loginWrap" v-loading="loading">
    <Header></Header>
    <div class="firmBgImg">
      <Carousel @setToLink="setToLink"></Carousel>
    </div>

    <div class="fxRow msRegister">
      <div class="fromWrap">
        <div class="msTitle">
          <span class="black45 fwb">{{ $t("login.loginTitle") }}</span>
        </div>
        <el-form :model="loginForm" ref="loginForm" :rules="rules" label-width="0px" @submit.native.prevent class="msContent">
          <el-form-item prop="username" class="wdb100 mb36">
            <el-input
              type="text"
              v-model="loginForm.username"
              :placeholder="$t('login.accPlaceholder')"
              @keyup.enter.native="loginSubmit('loginForm')"
              v-regexFilter="$halfWidthRegex"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" class="wdb100 mb60">
            <el-input type="password" :placeholder="$t('login.pwPlaceholder')" v-model="loginForm.password" @keyup.enter.native="loginSubmit('loginForm')" show-password></el-input>
            <p class="pt4 mb-26 tar forgetTips">
              <router-link to="/forget">{{ $t("login.forget") }}?</router-link>
            </p>
          </el-form-item>
          <div class="wdb100 login-btn">
            <el-button type="primary" @click="loginSubmit('loginForm')">{{ $t("login.loginTitle") }}</el-button>
          </div>
        </el-form>

        <div class="wdb100 pt6">
          <p class="lh30 loginTips">
            {{ $t("login.not") }}?
            <router-link to="/register">{{ $t("login.create") }}</router-link>
          </p>
        </div>

        <!-- 新手指引 - 英文 -->
        <div class="wdb100" v-if="getLanguage == 'en' && beginnerGuideLink">
          <p class="lh16 fs12 loginTips">
            {{ $t("login.guide") }}
            <a :href="beginnerGuideLink" target="_">{{ $t("login.learnMore") }}</a>
          </p>
        </div>

        <!-- 新手指引 - 中文 -->
        <div class="wdb100" v-if="getLanguage == 'zh' && beginnerGuideLinkCn">
          <p class="lh16 fs12 loginTips">
            {{ $t("login.guide") }}
            <a :href="beginnerGuideLinkCn" target="_">{{ $t("login.learnMore") }}</a>
          </p>
        </div>
      </div>
    </div>
    <div class="footBox">
      <p class="black88 fs12">
        {{ $t("login.copyright") }}
        <a href="https://beian.miit.gov.cn/" target="_blank" class="blue">{{ $t("login.records") }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Carousel from "./components/Carousel";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: null,
        password: null,
      },
      beginnerGuideLink: null, // 新手指导链接 - 英文
      beginnerGuideLinkCn: null, // 新手指导链接 - 中文
      clickSwitch: true, // 防止恶意提交
      rules: {
        username: [
          {
            required: true,
            message: this.$t("login.phoneHint"),
            trigger: "submit",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.passwordHint"),
            trigger: "submit",
          },
        ],
      },
      loading: false,
    };
  },
  components: {
    Header,
    Carousel,
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    ...mapActions("user", ["accountLogin", "coordinatorLogin"]),
    loginSubmit(loginForm) {
      this.$refs[loginForm].validate((valid, object) => {
        if (valid) {
          if (this.clickSwitch) {
            // 关闭提交按钮
            this.clickSwitch = false;
            this.accountLogin({
              username: this.loginForm.username,
              password: this.loginForm.password,
            })
              .then(res => {
                this.$message({
                  message: this.$t("login.succeed"),
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$router.replace("/");
                  },
                });
              })
              .catch(err => {
                this.clickSwitch = true;
              });
          }
        }
      });
    },
    // 获取systoken跳转登录
    async goSysTokenLogin() {
      const { token, id = "" } = this.$route.query;
      if (!token) return;
      this.loading = true;
      this.coordinatorLogin({ token, id })
        .then(res => {
          this.$message({
            message: this.$t("login.succeed"),
            type: "success",
            duration: 1000,
            onClose: () => {
              this.$router.replace("/");
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取新手指导链接
    setToLink(obj) {
      this.beginnerGuideLink = obj.beginnerGuideLink || null;
      this.beginnerGuideLinkCn = obj.beginnerGuideLinkCn || null;
    },
  },
  created() {
    this.goSysTokenLogin();
  },
};
</script>

<style lang="scss" scoped>
.loginWrap {
  width: 100%;
  min-width: 1200px;
  height: 100%;
  min-height: 800px;
  background: #f1f5fc;
  position: relative;
}

.firmBgImg {
  width: 60%;
  height: 100%;
  background: #f1f5fc;
}

.msRegister {
  width: 40%;
  height: 100%;
  background: #fafcff;
  box-shadow: 0px 21px 40px 0px rgba(208, 229, 255, 0.26);

  ::v-deep {
    .el-input__inner {
      background: #ffffff;
      border-color: #e1ecff;
      border-radius: 6px;
      height: 50px;
      line-height: 50px;
    }
  }
}

.fromWrap {
  width: 430px;
  margin: 0px auto;
}

.msTitle {
  width: 100%;
  text-align: center;
  padding-bottom: 60px;
  font-size: 22px;
}

.loginline {
  color: #e6e6e6;
}

.msContent {
  width: 100%;
}

.login-btn {
  text-align: center;
}

.login-btn button {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
}

.loginTips,
.forgetTips {
  font-size: 14px;
  line-height: 36px;
}

.loginTips {
  a {
    color: #0072ff;
  }
}

.forgetTips {
  a {
    color: #667288;
  }
}

.protocol:hover {
  color: #0072ff;
}

.footBox {
  position: absolute;
  bottom: 14px;
  left: 0;
  width: 60%;
  text-align: center;
  z-index: 10000;
}
</style>
